import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { STORE_CONST, SKIP_CONST } from '@/constants';
import ThemeConf from '@/types/ThemeConf';
import BTB_CONF from '@/btb-conf.json';
import { BtbConf } from '@/types/BtbConf';
import ScormOptions from '@bob-the-builder/kb4-scorm-client/dist/tsc/src/types/ScormOptions';
import kb4ScormClientHelper from '@/utils/kb4ScormClientHelper';

@Module({ namespaced: true, name: STORE_CONST.THEME_CONF_MODULE_NAME, store })
export class ThemeConfModule extends VuexModule {
  BTB_CONF: BtbConf = BTB_CONF;

  theme: ThemeConf | null = null;

  //TODO: getTheme could do the validation that now is under training
  get getTheme(): ThemeConf | null {
    return this.theme;
  }

  get getMetadata(): any {
    return kb4ScormClientHelper.getScormOptions().metadataScormResultFormat;
  }

  //TODO: add the same process to the skip_mode
  get passingScore() {
    if (this.theme && this.theme.passing_score !== undefined) return this.theme.passing_score;
    return BTB_CONF.passingScore;
  }  
  
  get testoutPassingScore() {
    if (this.theme && this.theme.testout_passing_score !== undefined) return this.theme.testout_passing_score;
    return 1;
  }

  get getScormOptions() :ScormOptions{
    return ({
      // if theme.scorm_result_format doesn't exist, uses METADA.scorm_result_format
      metadataScormResultFormat: this.theme?.scorm_result_format || this.getMetadata,
      playerVersion: BTB_CONF.playerInfo.version,
      debug: this.BTB_CONF.debug ?? false,
      scormless: this.BTB_CONF.scormless ?? false,
      defaultPassingScore: this.BTB_CONF.passingScore,
    });
  }

  get showCaptionsByDefault() {
    if (this.theme && this.theme.show_captions_by_default) return this.theme.show_captions_by_default;
    return BTB_CONF.showCaptionsByDefault;
  }

  get skipMode(){
    if(this.BTB_CONF.skipMode === SKIP_CONST.NO_SKIP) return SKIP_CONST.NO_SKIP;
    if(this.theme && this.theme.hasOwnProperty('skip_mode')) return this.theme.skip_mode ? SKIP_CONST.VIDEO_SKIP : SKIP_CONST.NO_SKIP;
    return this.BTB_CONF.skipMode;
  }

  get scormResultFormat(){
    if(this.theme && this.theme.hasOwnProperty('scorm_result_format'))
      return this.theme.scorm_result_format;
    return '';
  }
  get getCustomTermsSettings(){
    return this.theme?.custom_term_settings;
  } 

  @Mutation
  SET_THEME(theme: ThemeConf | null) {
    this.theme = theme;
  }

  @Action({ rawError: true })
  public setTheme(theme: ThemeConf | null) {
    this.context.commit('SET_THEME', theme);
  }
}
